export default function Courses({children,courses}){
    return <div className={courses}>{children}</div>
}